module.exports = __webpack_public_path__ + "static/media/8.00ed5777.jpg";